export default __webpack_public_path__ + "static/media/icon_customer_uncontracted.fc711344.svg";